import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts from "react-highcharts";
import seriesColor from "../../../../utils/seriesColor";
import { deepClone, shouldUpdate } from "../../../../utils";
import ToggleChartSeries from '../../../ToggleChartSeries/ToggleChartSeries';

import styles from "./styles.scss";

let count = 0;
const idPrefix = "LineChart";

const config = {
   chart: {
      animation: false,
      marginBottom: 85,
		zoomType: 'xy',
      panning: true,
      panKey: 'shift',
      style: {
          fontFamily: "Helvetica",
      }
   },
   credits: {
      enabled: false
   },
   colors: seriesColor.getSeriesColors(),
   title: {
      text: "Scatter Chart",
      align: "left",
      margin: 60,
      style: {
         color: "#4D4D4D",
         "font-size": "20px",
         "font-weight": "600"
      }
   },

    xAxis: {

    },
    yAxis: {

   },
   series: []
};
@CSSModules(styles, { allowMultiple: true })
class ScatterChart extends Component {
   constructor(props) {
      super(props);
		this.chart = React.createRef();
		this.config = deepClone(config);
		this.config.title.text = this.props.component.chartTitle || this.config.title.text;
   }

   render() {
    return (
        <div>
            <ReactHighcharts config={this.config} ref={this.chart} isPureConfig={true} />
            <ToggleChartSeries chart={this.chart} />
        </div>
    ) 
   }

   setup() {
      let chart = this.chart.current.getChart();
      if(chart) {
         this.props.loadData(this.props.component, chart, this.props.timePeriod, this.props.onLoadComplete);
         setTimeout(() => {
            if(chart) {
               chart.reflow();
               chart.redraw();
            }
         }, 100);
      }
   }

   teardown() {}

   componentDidMount() {
      this.setup();
   }

   componentDidUpdate(prevProps, prevState, snapshot) {
      this.setup();
   }

   shouldComponentUpdate(nextProps, nextState) {
    return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
}
}

const bindAction = dispatch => {
   return {
      loadData: (component, chart, timePeriod, onLoadComplete) => dispatch(actions.loadData(component, chart, timePeriod, onLoadComplete))
   };
};

const mapStateToProps = (state, ownProps) => ({});

export default connect(
   mapStateToProps,
   bindAction
)(ScatterChart);



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/ScatterChart/ScatterChart.js